import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { CarePlanSectionProps } from "../../../constants/constants";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { set } from "mobx";
import { InputTextarea } from "primereact/inputtextarea";
import { ListBox } from "primereact/listbox";
import {
  appAccentPanelStyle,
  appDialogContentStyle,
  appDialogHeaderStyle,
  appFormSectionStyle,
  appMutedTextStyle,
  appWideDialogStyle,
  renderSurfaceHeader,
} from "../../../components/general/uiSurfaceStyles";
import { useResponsive } from "../../../responsive/ResponsiveProvider";

interface SuggestedInstructionsDialogProps {
  suggestedInstructionsData: any[];
  submitButtonClick: (data: any) => void;
  showDialog: boolean;
  fieldName: string;
  onClose?: () => void;
}

const SuggestedInstructionsDialog: React.FC<SuggestedInstructionsDialogProps> = ({
  suggestedInstructionsData,
  submitButtonClick,
  showDialog,
  fieldName,
  onClose,
}) => {
  const [selectedInstructions, setSelectedInstructions] = useState<any[]>([]);
  const mobile = useResponsive().isNarrow;

  const onSaveClick = () => {
    let formattedInstructions = getConsolidatedData();
    setSelectedInstructions([]);
    submitButtonClick({
      fieldName: fieldName,
      instructions: formattedInstructions
    });
  };

  const getConsolidatedData = () => {
    let consolidatedInstructions = [...selectedInstructions];

    let formattedInstructions = "";
    consolidatedInstructions.forEach(instruction => {
      formattedInstructions = formattedInstructions.concat("* ");
      formattedInstructions = formattedInstructions.concat(instruction);
      formattedInstructions = formattedInstructions.concat("\n");
    });
    return formattedInstructions;
  }

  const onHideClick = () => {
    setSelectedInstructions([]);
    onClose && onClose();
  }

  return (
    <Dialog
      header={renderSurfaceHeader("Suggested Caregiver Instructions", "Select one or more suggestions to insert into the care plan.", "pi pi-list")}
      visible={showDialog}
      style={mobile ? { width: '90vw' } : appWideDialogStyle}
      headerStyle={appDialogHeaderStyle}
      contentStyle={appDialogContentStyle}
      onHide={onHideClick}
      breakpoints={{ '960px': '90vw', '640px': '100vw' }}>
      <div style={appAccentPanelStyle} className="mb-3">
        <div style={{ fontWeight: 700, color: "#9a3412" }}>Instruction picker</div>
        <div className="mt-2" style={appMutedTextStyle}>
          Choose every instruction you want to insert, then save to generate a formatted list.
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1em" }}>
        <div style={appFormSectionStyle}>
          <ListBox value={selectedInstructions} options={suggestedInstructionsData} multiple
            onChange={(e) => setSelectedInstructions(e.value)} optionLabel="name" placeholder="Select suggested instructions" className="w-full"
            listStyle={{ color: 'red' }} />
        </div>

        <Button label="Save" onClick={() => { onSaveClick() }} severity="warning" outlined rounded style={{ width: '20%' }} />
      </div>
    </Dialog>
  );
};

export default SuggestedInstructionsDialog;


